/*
    CCIS Assessment
*/
Postlogin = (function (postlogin) {
    postlogin.CCISAssessment = {
        assessmentId: null,
        assessmentGuid: null,
        userAssessmentId: null,
        assessmentUrl: null,
        assessment: null,
        items: null,
        options: null,
        numberOfItems: 0,
        numberOfItemsComplete: 0,
        currentItemIndex: null,
        furthestItemIndex: 0,
        progress: 0,
        soundEnabled: true,
        currentSound: null,
        optionsContainer: null,
        loadedItems: [],
        isDragging: false,
        autoplayAllowed: true,
        acceptingInput: false,

        queuedSounds: {},
        playingSounds: {},

        language: 'en',
        languageData: {
            es: {
                begin: 'Comience',
                continue: 'Continuar',
                seeResults: 'Ver Resultados',
                replay: 'Rehacer',
                myProgress: 'Mi Progreso',
                preposition: 'de',
            },
            en: {
                begin: 'Begin',
                continue: 'Continue',
                seeResults: 'See Results!',
                replay: 'Replay',
                myProgress: 'My Progress',
                preposition: 'of',
            },
        },

        sounds: {
            swoosh: `${Jr.getAssetsRoot()}/static/sounds/swoosh.mp3`,
            pick_up: `${Jr.getAssetsRoot()}/static/sounds/pick-up.mp3`,
            click: `${Jr.getAssetsRoot()}/static/sounds/click.wav`,
            correct: `${Jr.getAssetsRoot()}/static/sounds/correct.mp3`,
            cheers: `${Jr.getAssetsRoot()}/static/sounds/cheers.mp3`,
            'hotspot-click': `${Jr.getAssetsRoot()}/static/sounds/hotspot-click.mp3`,
        },
        loaded_sounds: {},
    };
    const me = postlogin.CCISAssessment;

    me.init = function () {
        me.assessmentId = $('#page-container').data('assessment-id');
        me.assessmentGuid = $('#page-container').data('assessment-guid');
        me.userAssessmentId = $('#page-container').data('user-assessment-id');
        me.assessmentUrl = $('#page-container').data('assessment-url');

        setTimeout(() => {
            // initialize all of the audio files we need
            $.each(me.sounds, (i, soundFile) => {
                me.preloadSound(soundFile);
            });
        }, 100);

        // try to detect if autoplay will work
        // if not, we need to show a 'begin' button
        // that the user can interact with
        const promise = document.createElement('video').play();
        if (promise instanceof Promise) {
            promise.catch((error) => {
                // Check if it is the right error
                if (error.name === 'NotAllowedError') {
                    me.autoplayAllowed = false;
                } else {
                    throw error;
                }
            });
        }

        me.loadSettings();
        me.initEvents();
        me.loadAssessment();
    };

    /**
     *  Load any saved preferences (sound)
     * */
    me.loadSettings = function () {
        // load cookies to see if we should remember any settings
        const soundCookie = Cookies.get('soundEnabled');
        if (typeof soundCookie !== 'undefined') {
            me.soundEnabled = soundCookie === 'true';
            me.updateSoundIcon();
        }
    };

    me.initEvents = function () {
        $(document).on('keydown', (event) => {
            if (me.acceptingInput) {
                if (event.which >= 49 && event.which <= 53) {
                    event.preventDefault();

                    Postlogin.CCISAssessment.setAcceptingInput(false);
                    me.loadedItems[me.currentItemIndex].makeSelection(event.which - 48);
                }

                if (event.which >= 97 && event.which <= 101) {
                    event.preventDefault();

                    Postlogin.CCISAssessment.setAcceptingInput(false);
                    me.loadedItems[me.currentItemIndex].makeSelection(event.which - 96);
                }

                if (event.which === 32 || event.which === 13) {
                    event.preventDefault();

                    Postlogin.CCISAssessment.setAcceptingInput(false);
                    me.loadedItems[me.currentItemIndex].makeSelection(event.target.getAttribute('data-option-index'));
                }
            }
        });

        document.querySelector('#change-language-btn').addEventListener('click', () => {
            me.toggleLanguage();
        });

        $('body').on('click', '#next-item', function () {
            $(this).blur(); // remove focus from this element
            me.nextItem();
        });
        $('body').on('click', '#previous-item', function () {
            $(this).blur(); // remove focus from this element
            me.previousItem();
        });

        $('body').on('click', '#beep-9-modal:not(.activated)', function () {
            if (!$(this).hasClass('activated')) {
                me.showInstructions();
            }
        });

        $('body').on('click', '.has-audio', function (e) {
            const sound = $(this).data('audio');
            e.stopPropagation();
            e.preventDefault();
            if (!me.isDragging) {
                Postlogin.CCISAssessment.playSound(sound);
            }

            return false;
        });

        $('body').on('click', '.option-audio', function (e) {
            const sound = $(this).data('audio');
            e.stopPropagation();
            e.preventDefault();
            if (!me.isDragging) {
                Postlogin.CCISAssessment.playSound(sound);
            }

            return false;
        });

        $('#item-controls').on('click', '.item-fullscreen-button', () => {
            Postlogin.CCISAssessment.setInPlatformFullscreenMode(!Postlogin.CCISAssessment.isInPlatformFullscreenMode());
            Postlogin.CCISAssessment.toggleFullScreen();
        });

        $('#item-controls').on('click', '.item-mute-button', () => {
            me.soundEnabled = !me.soundEnabled;
            Postlogin.CCISAssessment.stopAllSounds();
            Cookies.set('soundEnabled', me.soundEnabled);
            me.updateSoundIcon();
        });
    };

    me.toggleLanguage = () => {
        me.language = me.language === 'en' ? 'es' : 'en';
        const { assessment, languageData, language } = me;
        me.loadedItems = [];

        const container = document.querySelector('#page-container');
        container.innerHTML = '';
        me.numberOfItemsComplete = 0;
        me.loadAllItems();

        // now do the modal:
        document.querySelector('#beep-9-modal .content-container .beep-9-modal-content h2').innerHTML = language === 'en' ? assessment.instructions_title : assessment[`instructions_title_${language}`];
        document.querySelector('.btn-replay-audio').innerHTML = `${languageData[language].replay} <i class="fa fa-volume-up"></i>`;

        document.querySelector('#modal-instructions-body').innerHTML = language === 'en' ? assessment.instructions : assessment[`instructions_${language}`];
        document.querySelector('.btn-continue').innerHTML = languageData[language].continue;
        document.querySelector('.my-progress-text').innerHTML = languageData[language].myProgress;
        const preposition = document.querySelector('.my-progress-button .preposition');
        if (preposition) {
            preposition.innerHTML = languageData[language].preposition;
        }
        // document.querySelector('#user-interaction-button')
        //     .innerHTML = languageData[language].begin;
    };

    me.loadAllItems = () => {
        const { items } = me;
        let firstUnansweredQuestion = null;
        me.currentItemIndex = 0;

        items.forEach((q, index) => {
            const question = q;
            question.first = index === 0;
            question.last = index === me.numberOfItems - 1;
            question.itemIndex = index;
            question.userAssessmentId = me.userAssessmentId;

            if (question.response) {
                question.completed = true;
                me.furthestItemIndex = index;
                me.numberOfItemsComplete++;
            } else {
                question.completed = false;
                firstUnansweredQuestion = firstUnansweredQuestion ?? index;
            }
        });
        me.currentItemIndex = firstUnansweredQuestion;

        items.forEach((q, itemIndex) => {
            me.loadItem(itemIndex);
        });
    };

    me.loadItem = (itemIndex) => {
        if (typeof me.loadedItems[itemIndex] !== 'undefined') {
            return;
        }

        me.loadedItems[itemIndex] = new Postlogin.CCISAssessment.Item(me.items[itemIndex]);
        me.loadedItems[itemIndex].init();
    };

    me.loadAssessment = function () {
        // fetch the assessment data
        $.getJSON(me.assessmentUrl, (result) => {
            const {
                assessment, items, options, user_assessment: userAssessment,
            } = result.data;
            me.assessment = assessment;
            me.items = items;
            me.options = options;
            me.numberOfItems = items.length;
            me.language = userAssessment?.assigned_language ?? 'en';

            me.loadAllItems();

            // create progress menu
            Postlogin.CCISAssessment.Progress.populate(me.items);

            me.updateProgress();
            me.showInstructions();
        });
    };

    me.showInstructions = function () {
        const { language, languageData, assessment } = me;
        const playInstructionsAudio = function () {
            $('#beep-9-modal .btn-replay-audio').fadeOut();

            if (assessment.instructions_audio && Postlogin.CCISAssessment.isSoundEnabled()) {
                if (
                    !$(`#segment-${Postlogin.CCISAssessment.getCurrentItemIndex()}`).hasClass(
                        `dont-disable-feedback-${me.assessmentId}continue`,
                    )
                ) {
                    $('#beep-9-modal .btn-continue').prop('disabled', true);
                }

                const instructionsAudio = language === 'en' ? assessment.instructions_audio : assessment[`instructions_audio_${language}`];

                Postlogin.CCISAssessment.playSound(instructionsAudio, 500, null, () => {
                    $('#beep-9-modal .btn-replay-audio').fadeIn();
                    $('#beep-9-modal .btn-continue').prop('disabled', false);
                    $(`#segment-${Postlogin.CCISAssessment.getCurrentItemIndex()}`).addClass(
                        `dont-disable-feedback-${me.assessmentId}continue`,
                    );
                });
            }
        };

        Postlogin.CCISAssessment.setAcceptingInput(false);

        const modalContentContainer = `
            <div id="modal-content-container">
                <div id="modal-instructions-body">
                    ${language === 'en' ? assessment.instructions : assessment[`instructions_${language}`]}
                </div>
            </div>
        `;

        const modalFooter = $('#beep-9-modal .content-container > .beep-9-modal-content, #beep-9-modal .content-container > footer');
        if (!me.autoplayAllowed) {
            modalFooter.addClass('hidden');
            const userInteractionButton = $(
                `<div id="user-interaction-button" class="btn btn-lg btn-hollow-green">${languageData[language].begin}</div>`,
            );

            userInteractionButton.on('click', () => {
                me.autoplayAllowed = true;
                $('#user-interaction-button').addClass('removed');
                setTimeout(() => {
                    $('#user-interaction-button').remove();
                }, 500);
                modalFooter.removeClass('hidden');
                playInstructionsAudio();
            });
            $('#beep-9-modal').append(userInteractionButton);
        }

        // show the instructions modal window
        const instructionsTitle = language === 'en' ? assessment.instructions_title : assessment[`instructions_title_${language}`];
        Postlogin.CCISAssessment.Popup.showModal({
            title: instructionsTitle,
            body: modalContentContainer,
            overlay: 'light',
            smaller: false,
            actions: [
                {
                    label: languageData[language].continue,
                    cssClass: 'btn-xl btn-success btn-continue',
                    onClick(e) {
                        e.stopPropagation();
                        Postlogin.CCISAssessment.Popup.hideModal();
                    },
                },
                {
                    label: `${languageData[language].replay} <i class="fa fa-volume-up"></i>`,
                    cssClass: 'btn-replay-audio btn-default pull-left',
                    onClick(e) {
                        e.stopPropagation();
                        const instructionsAudio = me.language === 'en' ? assessment.instructions_audio : assessment[`instructions_audio_${me.language}`];
                        $(this).fadeOut();
                        Postlogin.CCISAssessment.playSound(instructionsAudio, 0, null, () => {
                            $('#beep-9-modal .btn-replay-audio').fadeIn();
                        });
                    },
                },
                {
                    label: '<i class="fa fa-globe fa-3x" aria-hidden="true"></i>',
                    cssClass: 'btn-modal-toggle-language btn-hollow-blue',
                    onClick: () => {
                        me.toggleLanguage();
                    },
                },
            ],
            onShow() {
                if (me.autoplayAllowed) {
                    playInstructionsAudio();
                }

                const escKey = function (event) {
                    if (+event.which === 27) {
                        Postlogin.CCISAssessment.Popup.hideModal();
                    }
                };

                $(document).one('keydown', escKey);
            },
            onHide() {
                // go to the current item
                Postlogin.CCISAssessment.goToItem(me.currentItemIndex);
                Postlogin.CCISAssessment.hideShowResultsButton();
                Postlogin.CCISAssessment.setAcceptingInput(true);
            },
        });
    };

    me.showCompletion = function () {
        const { language, assessment, languageData } = me;
        const completionBody = `
            <div>${language === 'en' ? assessment.completion_text : assessment[`completion_text_${language}`]}</div>
        `;
        const completionTitle = language === 'en' ? assessment.completion_title : assessment[`completion_title_${language}`];
        const completionAudio = language === 'en' ? assessment.completion_audio : assessment[`completion_audio_${language}`];

        let actions = [];
        if (me.userAssessmentId == null) {
            actions = [
                {
                    label: `${languageData[language].replay} <i class="fa fa-volume-up"></i>`,
                    cssClass: 'btn-replay-audio btn-default pull-left',
                    onClick(e) {
                        e.stopPropagation();
                        $(this).fadeOut();
                        Postlogin.CCISAssessment.playSound(completionAudio, 0, null, () => {
                            $('#beep-9-modal .btn-replay-audio').fadeIn();
                        });
                    },
                },
            ];
        } else {
            actions = [
                {
                    label: `${languageData[language].seeResults} <i class="fa fa-volume-up"></i>`,
                    cssClass: 'btn-xl btn-success btn-continue',
                    onClick(e) {
                        e.stopPropagation();
                        window.location.replace(`/assessment/ccis/${me.assessmentId}/${me.userAssessmentId}/results/?language=${language}`);
                    },
                },
                {
                    label: `${languageData[language].replay} <i class="fa fa-volume-up"></i>`,
                    cssClass: 'btn-replay-audio btn-default pull-left',
                    onClick(e) {
                        e.stopPropagation();
                        $(this).fadeOut();
                        Postlogin.CCISAssessment.playSound(completionAudio, 0, null, () => {
                            $('#beep-9-modal .btn-replay-audio').fadeIn();
                        });
                    },
                },
            ];
        }

        // show the completion modal window
        Postlogin.CCISAssessment.Popup.showModal({
            title: completionTitle,
            body: completionBody,
            class: '',
            overlay: 'dark',
            smaller: false,
            actions,
            onShow() {
                $('#beep-9-modal .btn-replay-audio').fadeOut();
                if (completionAudio && Postlogin.CCISAssessment.isSoundEnabled()) {
                    if (
                        !$(`#segment-${Postlogin.CCISAssessment.getCurrentItemIndex()}`).hasClass(
                            `dont-disable-feedback-${me.assessmentId}continue`,
                        )
                    ) {
                        $('#beep-9-modal .btn-continue').prop('disabled', true);
                    }
                    Postlogin.CCISAssessment.playSound(completionAudio, 500, null, () => {
                        $('#beep-9-modal .btn-replay-audio').fadeIn();
                        $('#beep-9-modal .btn-continue').prop('disabled', false);
                        $(`#segment-${Postlogin.CCISAssessment.getCurrentItemIndex()}`).addClass(
                            `dont-disable-feedback-${me.assessmentId}continue`,
                        );
                    });
                }
            },
            onHide() {
                if (me.userAssessmentId != null) {
                    window.location.replace(`/assessment/ccis/${me.assessmentId}/${me.userAssessmentId}/results/?language=${language}`);
                }
            },
        });
    };

    me.updateNumberComplete = function () {
        me.numberOfItemsComplete++;
        me.updateProgress();

        if (me.numberOfItemsComplete >= me.numberOfItems) {
            me.showCompletion();
        }
    };

    me.updateProgress = function () {
        me.progress = Math.round((me.numberOfItemsComplete / me.numberOfItems) * 100);
        Postlogin.CCISAssessment.Progress.updatePercentComplete(me.progress);

        document.querySelector('.my-progress-text').innerHTML = me.languageData[me.language].myProgress;
        const progressPreposition = document.querySelector('.my-progress-button .preposition');
        if (progressPreposition) {
            progressPreposition.innerHTML = me.languageData[me.language].preposition;
        }
    };

    me.hideShowResultsButton = function () {
        me.progress = Math.round((me.numberOfItemsComplete / me.numberOfItems) * 100);
        $('.results-text').text(me.languageData[me.language].seeResults);

        if (+me.progress === 100) {
            $('#results-button').addClass('enabled');
        } else {
            $('#results-button').removeClass('enabled');
        }
    };

    me.getCurrentItemIndex = function () {
        return me.currentItemIndex;
    };

    me.getFurthestItemIndex = function () {
        return me.furthestItemIndex;
    };

    me.setCurrentItemIndex = function (index) {
        me.currentItemIndex = index;
    };

    me.getLanguageSetting = function () {
        return me.language;
    };

    me.renderOptions = function (response, pastOrFutureClass) {
        const responseId = response ? +response.assessment_option_id : 0;
        return `
            <div class="options-container">
                    ${me.options
            .map((option, index) => {
                const optionText = me.language === 'en' ? option.option_text : option[`option_text_${me.language}`];
                return `
                            <div class="item-option ${+option.assessment_option_id === responseId ? 'selected' : 'not-selected'}"
                                data-value="${_.escape(option.value)}"
                                data-option-index="${index + 1}"
                                data-option-id="${_.escape(option.assessment_option_id)}"
                                ${pastOrFutureClass === '' ? 'tabindex="0"' : ''}
                            >
                                <div class="${_.escape(option.option_slug)} emoji-img"></div>
                                <div class="option-text">
                                    <span>${_.escape(optionText)}</span>
                                </div>
                            </div>
                        `;
            })
            .join('')}
            </div>
        `;
        // the join is here because mapping an array creates a comma separated list and this removes the commas from the DOM output
    };

    me.preloadSound = function (src) {
        if (!src) return null;
        let sound = document.createElement('audio');
        if ('src' in sound) {
            sound.autoPlay = false;
        } else {
            sound = document.createElement('bgsound');
            sound.volume = -10000;
        }
        sound.src = src;
        $('body').append(sound);
        me.loaded_sounds[src] = sound;

        return me.loaded_sounds[src];
    };

    me.nextItem = function () {
        me.goToItem(parseInt(me.currentItemIndex, 10) + 1);
    };

    me.previousItem = function () {
        me.goToItem(parseInt(me.currentItemIndex, 10) - 1);
    };

    me.goToItem = function (itemIndex) {
        if (itemIndex < 0 || typeof me.items[itemIndex] === 'undefined') {
            return;
        }

        $('#clouds-background-container').css(
            'backgroundPosition',
            `-${(itemIndex - 1) * 280}px 260px, -${(itemIndex - 1) * 100}px 260px, -${(itemIndex - 1) * 180}px 260px, -${
                (itemIndex - 1) * 70
            }px 260px`,
        );

        Postlogin.CCISAssessment.Progress.selectItem(itemIndex);

        const previousItemIndex = me.currentItemIndex;
        me.currentItemIndex = itemIndex;

        if (me.currentItemIndex > previousItemIndex) {
            me.loadedItems[previousItemIndex].moveOutLeft();
            me.loadedItems[previousItemIndex].hide();
            me.loadedItems[me.currentItemIndex].moveInLeft();
            me.loadedItems[me.currentItemIndex].show();
        } else {
            me.loadedItems[previousItemIndex].moveOutRight();
            me.loadedItems[previousItemIndex].hide();
            me.loadedItems[me.currentItemIndex].moveInRight();
            me.loadedItems[me.currentItemIndex].show();
        }

        Postlogin.CCISAssessment.Progress.updatePageNumber(parseInt(me.currentItemIndex, 10) + 1, me.numberOfItems);
    };

    me.setAcceptingInput = function (value) {
        me.acceptingInput = value;
    };

    me.getAcceptingInput = function () {
        return me.acceptingInput;
    };

    me.showNextButton = function () {
        $('#next-item').addClass('enabled');
    };

    /**
     * Play the specified sound at the specified volume.
     * (Clones the sound)
     * */
    me.playSound = (src, delay = 0, callback = null, onEnd = null) => {
        me.stopAllSounds();

        let thisSound = null;

        // if this sound object is already created, use that
        if (typeof me.sounds[src] !== 'undefined') {
            thisSound = me.loaded_sounds[src].cloneNode(false);
        } else {
            // otherwise, create sound object
            thisSound = me.preloadSound(src);
        }

        thisSound.volume = me.soundEnabled ? 1 : 0;

        if (me.soundEnabled) {
            const safetyTimeoutId = setTimeout(() => {
                $('#beep-9-modal .btn-continue .progress').remove();
                $('#beep-9-modal .btn-continue').prop('disabled', false);
            }, 10000);

            thisSound.addEventListener('play', () => {
                const { duration } = thisSound;
                $('#beep-9-modal .btn-continue .progress').css('transition', `all ${duration}s ease-in-out`);
                $('#beep-9-modal .btn-continue .progress').addClass('complete');
            });

            thisSound.addEventListener('loadedmetadata', () => {
                $('#beep-9-modal .btn-continue').append($('<div class="progress"></div>'));

                if (delay > 0) {
                    me.queuedSounds[src] = setTimeout(() => {
                        me.currentSound = thisSound;
                        delete me.queuedSounds[src];
                        me.playingSounds[src] = thisSound;
                        thisSound.play();
                        if (typeof callback === 'function') {
                            callback();
                        }
                    }, delay);
                } else {
                    me.currentSound = thisSound;
                    me.playingSounds[src] = thisSound;
                    thisSound.play();

                    if (typeof callback === 'function') {
                        callback();
                    }
                }
            });

            thisSound.addEventListener(
                'ended',
                function () {
                    const $src = $(this).attr('src');
                    if (me.currentSound === me.playingSounds[$src]) {
                        me.currentSound = null;
                    }

                    thisSound.currentSrc = null;
                    thisSound.src = '';
                    thisSound.srcObject = null;
                    thisSound.remove();

                    delete me.playingSounds[$src];
                    $(this).remove();
                    if (typeof onEnd === 'function') {
                        onEnd();
                    }
                    setTimeout(() => {
                        $('#beep-9-modal .btn-continue .progress').remove();
                    }, 500);
                    clearTimeout(safetyTimeoutId);
                },
                false,
            );
        } else {
            // if sound is muted, call any callback function immediately
            if (typeof callback === 'function') {
                callback();
            }
            // and call the onEnd function after the specified delay
            setTimeout(() => {
                if (typeof onEnd === 'function') {
                    onEnd();
                }
            }, delay);
        }

        return thisSound;
    };

    /**
     * Play the specified sound effect at the specified volume.
     * (Clones the sound)
     * */
    me.playSoundEffect = function (name, volume = 1, delay = 0) {
        const thisSound = me.loaded_sounds[me.sounds[name]].cloneNode(false);
        thisSound.volume = me.soundEnabled ? volume : 0;
        if (me.soundEnabled) {
            thisSound.addEventListener(
                'ended',
                function () {
                    $(this).remove();
                },
                false,
            );
            if (delay > 0) {
                setTimeout(() => {
                    const isPlaying = thisSound.currentTime > 0 && !thisSound.paused && !thisSound.ended && thisSound.readyState > 2;

                    if (!isPlaying) {
                        thisSound.play();
                    }
                }, delay);
            } else {
                const isPlaying = thisSound.currentTime > 0 && !thisSound.paused && !thisSound.ended && thisSound.readyState > 2;

                if (!isPlaying) {
                    thisSound.play();
                }
            }
        }

        return thisSound;
    };

    me.stopAllSounds = function (queued = true, playing = true) {
        if (queued) {
            // eslint-disable-next-line no-restricted-syntax
            for (const src in me.queuedSounds) {
                if (typeof me.queuedSounds[src] !== 'undefined') {
                    clearTimeout(me.queuedSounds[src]);
                    delete me.queuedSounds[src];
                }
            }
        }
        if (playing) {
            // eslint-disable-next-line no-restricted-syntax
            for (const src in me.playingSounds) {
                if (typeof me.playingSounds[src] !== 'undefined') {
                    me.playingSounds[src].pause();
                    $(me.playingSounds[src]).remove();
                    delete me.playingSounds[src];
                }
            }
        }
    };

    me.isSoundEnabled = function () {
        return me.soundEnabled;
    };

    me.getUserAssessmentId = function () {
        return me.userAssessmentId;
    };

    me.updateSoundIcon = function () {
        if (me.soundEnabled) {
            $('#item-controls .item-mute-button .fa-ban').fadeOut();
            $('body').removeClass('sound-disabled');
        } else {
            $('#item-controls .item-mute-button .fa-ban').fadeIn();
            $('body').addClass('sound-disabled');
        }
    };

    return postlogin;
}(Postlogin || {}));
